const news = [
  {
    pic: require('../assets/news/hulianwangdahui.jpg'),
    newsTitle: '点赞！音书科技CEO石城川入选第一批“全球青年领军者计划”...',
    newsDetail: '2023年是乌镇峰会第十年。以此为契机，大会首次创立“全球青年领军者计划”，共有来自14个国家和地区的18位优秀青年入选，其中包括广州音书科技有限公司创始人兼CEO石城川...',
    src: 'https://mp.weixin.qq.com/s/wZML5WIsYbWma1y2r_dZEw'
  },
  {
    pic: require('../assets/news/cwi.jpg'),
    newsTitle: 'Voibook’s artificial intelligence-based service platform enhances ...',
    newsDetail: 'In a world without sound, it’s difficult to make friends, attend school, find a job, and even get medical care. In China, 72 million ...',
    src: 'https://www.cartierwomensinitiative.com/fellow/chengchuan-shi'
  },
  {
    pic: require('../assets/news/fudan.jpg'),
    newsTitle: '复旦新生石城川：听不见，就让声音被“看见”...',
    newsDetail: '2022级复旦大学MBA新生、公益奖学金获得者，在无声世界里摸索长大，广州市番禺区音书无障碍沟通研究中心创始人之一，音书科技创始人兼CEO，如今，他让100万听障人士的声音被“看见”...',
    src: 'https://mp.weixin.qq.com/s/NF8NEuBLwVQ7mIwty6x-5Q'
  },
  {
    pic: require('../assets/news/xinqingnian.jpeg'),
    newsTitle: '“看见”声音后，美姐10年来第一次去开了家长会...',
    newsDetail: '18岁他上了大学，要靠唇语和板书理解教学内容，即便听不见他还会跟着点头。失聪隔绝了他与社会，却不妨碍他渴望有声世界，他开发出这个“第三只耳朵”想让听障人士“看见”声音...',
    src: 'https://mp.weixin.qq.com/s/Ujka9R5rnwKvMUCj-p3TGA'
  },
  {
      pic: require('../assets/news/sunchunlan.jpg'),
      newsTitle: '孙春兰副总理接见！华南理工毕业生在这场重要会议上作汇报发言...',
      newsDetail: '中共中央政治局委员、国务院副总理孙春兰17日在中国农业大学考察2021届高校毕业生就业促进周时强调，要深入贯彻习近平总书记关于高校毕业生就业工作的重要指示...',
      src: 'https://mp.weixin.qq.com/s/dCskEBiy5ym7V8lir2djEQ'
  },
  {
      pic: require('../assets/news/ergeng.png'),
      newsTitle: '广东90后失聪CEO入选福布斯，影响60万人...',
      newsDetail: '世卫组织在2019年公布的数据显示，全球约11亿年轻人(12-35岁之间)正面临无法逆转的听力损失风险，个人音频设备音量过大，例如用耳机听音乐是造成风险的重要原因...',
      src: 'https://mp.weixin.qq.com/s/vJ-FpiWI5c36QvToYdl-nw'
  },
  {
      pic: require('../assets/news/asian.jpeg'),
      newsTitle: '音书科技石城川、陈国强入选2020福布斯亚洲“30位30岁以下精英”',
      newsDetail: '日前，福布斯发布了2020年亚洲地区30位30岁以下精英榜 (Forbes 30 Under 30 Asia 2020)，音书科技创始人石城川、陈国强入选...',
      src: 'https://mp.weixin.qq.com/s/EA5dW3tG2YLyEj8dS40LSw'
  },
  {
      pic: require('../assets/news/fbs.png'),
      newsTitle: '入选福布斯中国30岁以下精英榜，他要用技术让声音“看得见”！',
      newsDetail: '10月17日，福布斯中国推出了最新的30岁以下精英榜（30 Under 30），评选出涉及多个领域的青年创新创业精英。其中，华南理工大学校友、创新创业孵化基地团队——音书科技CTO陈国强上榜...',
      src: 'https://mp.weixin.qq.com/s/cklvIarlT3hDC9-4WlCYHA'
  },
  {
      pic: require('../assets/news/fbs2.webp'),
      newsTitle: '音书科技创始人石城川、陈国强入选2019福布斯中国30岁以下精英榜',
      newsDetail: '10月17日，福布斯中国正式发布2019年度30岁以下精英榜，音书科技创始人石城川、陈国强入选...',
      src: 'https://mp.weixin.qq.com/s/xITfWpferckeYKdjuiv6gQ'
  },
  {
      pic: require('../assets/news/phone.webp'),
      newsTitle: '听力残疾人使用手机软件接听电话收看直播视频指南',
      newsDetail: '网上有很多直播视频，还有大量的公开课没有字幕，可以使用音频线，将电脑上的视频声音通过音频线传到手机上，在音书APP上收看语音转文字...',
      src: 'https://mp.weixin.qq.com/s/GEFLNBf-_B81qQRdoUH9Lg'
  },
  {
      pic: require('../assets/news/scc2.webp'),
      newsTitle: '人物 | 他帮听障人士寻回“声音”',
      newsDetail: '3月3日是全国爱耳日，大学毕业生石城川有不少关于听障人士的愿望期待实现。4年前，重度听力障碍的他立志解决听障人士沟通的痛点，通过人工智能技术开发无障碍沟通软件、智能字幕速记系统等科技手段，帮助听障人士无障碍沟通。...',
      src: 'https://mp.weixin.qq.com/s/5IQpTMH0jE6diltCZHPqeA'
  },
  {
      pic: require('../assets/news/voibook2.jpg'),
      newsTitle: '推出语音交流辅助产品，音书科技想实现听障人士的无障碍沟通',
      newsDetail: '在国内，音书科技也在做这样的事情。成立于2016年7月，音书科技主要从事听障交流app和AR眼镜开发。团队创始人石城川本身就是听障人士，暨南大学毕业后任跨国公司工程师，后辞职与华南理工大学校友陈国强和彭驷庆合作创办了音书科技...',
      src: 'https://36kr.com/p/5080577'
  }
]

export default news



// WEBPACK FOOTER //
// ./src/lib/news-list.js